import TagManager from "react-gtm-module";
const defaultCity = "blitar";

// ponytail: GTM container (GTM-5LXZXQ3C) is loaded by public/index.html; this only pushes events.
function sendEvent(payload) {
  const event = {
    dataLayer: {
      ...payload,
      user_id: "not login yet",
    },
  };
  TagManager.dataLayer(event);
}

export default {
  sendEvent,
  defaultCity,
};
